import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/simulator-configs/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/simulator-configs/delete`,
        endpoint: `${endpointBackend}gci/simulator-configs/getall`
    }

    let list = {
        labelTitle: 'Configurações - Simulador',
        labelTitleButtonAdd: 'Incluir nova configuração',
        fieldsShowOnDelete: [''],
        canAdd: false,
        canDelete: false,
        columns: [
            {
                name: 'name',
                label: 'Parceiro',
                value: 'aaa'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
